import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

export const NOT_FOUND_CONFIG = '@NOMIDIO_ANGULAR:NOT_FOUND_CONFIG';

export interface NotFoundConfig {
  links?: NotFoundLink[];
}

export interface NotFoundLink {
  href: string;
  label: string;
}

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false
})
export class NotFoundComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  @HostBinding('class.nom-error-page')
  public readonly nomErrorPage = true;

  public links: NotFoundLink[] | null = null;

  public ngOnInit(): void {
    this.route.data.subscribe(data => {
      if (data[NOT_FOUND_CONFIG]) {
        const config: NotFoundConfig = data[NOT_FOUND_CONFIG];
        this.links = config.links ?? null;
      } else {
        this.links = null;
      }
    });
  }
}
